import { default as packageInfo } from '../../../../../package.json';
import { Environment } from './environment.interface';

export const environment: Environment = {
  appVersion: packageInfo.version,
  production: true,
  releaseName: 'smart-core-guest-area',
  releasePhase: 'test',
  api: 'https://api.test.mysmarthotel.co/api-router',
  demoGA: 'damian.test.mysmarthotel.co',
  appViewUrl: 'https://api.test.mysmarthotel.co/app-views',
  translationDevMode: true,
  aiWhatsApp: '48732085630',
  myGuestUrl: 'https://myguest-9f04f.web.app',
};
